import * as React from 'react';
import * as Glob from '../Globale';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { InputLimite } from './InputLimite';

interface IInputCalcolatoreProps extends Dati.IBaseProps {
    IdA: string;
    IdB: string;
    NameA: string;
    NameB: string;
    MinimoA?: number;
    MinimoB?: number;
    MassimoA?: number;
    MassimoB?: number;
    Buono: number;
    BuonoFrase: string;
    Accettabile: number;
    AccettabileFrase: string;
    Scarso: number;
    ScarsoFrase: string;
    ValoreA: number;
    ValoreB: number;
    IndicatoreA?: string;
    IndicatoreB?: string;
    IndicatoreC?: string;
    LabelA?: string;
    LabelB?: string;
    LabelC?: string;
    SuccessCSS?: string;
    DangerCSS?: string;
    WarningCSS?: string;
    Operazione: string;
    IncrementoA?: number;
    IncrementoB?: number;
    Verso?: string;
}

export class InputCalcolatore extends BasePureComponent<IInputCalcolatoreProps, {}> {

    private _IndicatoreC = <span></span>;
    private _LabelA: string;
    private _LabelB: string;
    private _LabelC: string;
    private _ValoreC: number = 0;
    private _SuccessCSS: string = "";
    private _DangerCSS: string = "";
    private _WarningCSS: string = "";
    private _IncrementoA: number;
    private _IncrementoB: number;

    public constructor(props: any) {
        super(props);

        this._ValoreC = this.Calcola();

        Glob.Log(Glob.LogCat.InputCalcolatore, false, "VALORE A1", this.props.ValoreA);
        Glob.Log(Glob.LogCat.InputCalcolatore, false, "VALORE B1", this.props.ValoreB);

        this.props.IndicatoreC == undefined ? this._IndicatoreC = <span></span> : this._IndicatoreC = <span className="input-group-addon bootstrap-touchspin-prefix">{this.props.IndicatoreC}</span>;
        this.props.LabelA == undefined ? this._LabelA = "" : this._LabelA = this.props.LabelA;
        this.props.LabelB == undefined ? this._LabelB = "" : this._LabelB = this.props.LabelB;
        this.props.LabelC == undefined ? this._LabelC = "" : this._LabelC = this.props.LabelC;
        this.props.IncrementoA == undefined ? this._IncrementoA = 1 : this._IncrementoA = this.props.IncrementoA;
        this.props.IncrementoB == undefined ? this._IncrementoB = 1 : this._IncrementoB = this.props.IncrementoB;
    }

    private Calcola(): number {
        var newValore: number = 0;
        switch (this.props.Operazione) {
            case "+":
                newValore = (this.props.ValoreA * 1) + (this.props.ValoreB * 1);
                break;
            case "-":
                newValore = (this.props.ValoreA * 1) - (this.props.ValoreB * 1);
                break;
            case "*":
                newValore = (this.props.ValoreA * 1) * (this.props.ValoreB * 1);
                break;
            case "/":
                if ((this.props.ValoreB * 1) != 0) {
                    newValore = (this.props.ValoreA * 1) / (this.props.ValoreB * 1);
                }
                break;
        }
        return newValore;
    }

    public render() {
        this._ValoreC = this.Calcola();

        var indicatoreA = <span></span>;
        if (this.props.IndicatoreA != undefined) {
            indicatoreA = <span className="input-group-addon bootstrap-touchspin-prefix">{this.props.IndicatoreA}</span>
        }

        var indicatoreB = <span></span>;
        if (this.props.IndicatoreB != undefined) {
            indicatoreB = <span className="input-group-addon bootstrap-touchspin-prefix">{this.props.IndicatoreB}</span>
        }

        return <div>
            <InputLimite
                Label={this._LabelA}
                Visibile={this.props.Visibile}
                Scrittura={this.props.Scrittura}
                Id={this.props.IdA}
                Name={this.props.NameA}
                Indicatore={this.props.IndicatoreA}
                Massimo={this.props.MassimoA}
                Minimo={this.props.MinimoA}
                Valore={this.props.ValoreA}
                OnChange={(e) => { this.props.OnChange(e); }}
                Incremento={this._IncrementoA}
                CSS={this.props.CSS} />
            <InputLimite
                Label={this._LabelB}
                Visibile={this.props.Visibile}
                Scrittura={this.props.Scrittura}
                Id={this.props.IdB}
                Indicatore={this.props.IndicatoreB}
                Name={this.props.NameB}
                Massimo={this.props.MassimoB}
                Minimo={this.props.MinimoB}
                Valore={this.props.ValoreB}
                OnChange={(e) => { this.props.OnChange(e); }}
                Incremento={this._IncrementoB}
                CSS={this.props.CSS} />
            <InputLimite
                ref={(r) => { if (r != undefined) r.SetValore(this._ValoreC) }}
                Label={this._LabelC}
                Visibile={this.props.Visibile}
                Scrittura={false}
                Id={this.props.Id}
                Name={this.props.Name}
                OnChange={(e) => { }}
                Valore={this._ValoreC}
                AbilitaDecremento={false}
                AbilitaIncremento={false}
                Buono={this.props.Buono}
                BuonoFrase={this.props.BuonoFrase}
                Accettabile={this.props.Accettabile}
                AccettabileFrase={this.props.AccettabileFrase}
                Scarso={this.props.Scarso}
                ScarsoFrase={this.props.ScarsoFrase}
                AbilitamentoBackGroundColor
                CSS={this.props.CSS}
                Verso={this.props.Verso} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/InputCalcolatore.tsx